import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label, Btn } from 'components';
import { ReactComponent as ImgApproveReject } from 'assets/img/status/img_interview_no_approve.svg';

interface Props {
    rjectInfoList: Array<string>;
    href: string;
}

function ApproveReject({ rjectInfoList, href }: Props): React.ReactElement {
    return (
        <FormStatusInfo
            subTitle={['직원 등록 승인 거절되었습니다.']}
            image={<ImgApproveReject />}
            btnWidth={180}
            btn={
                <Btn height={44} fontStyle={'body2'} backGroundColor={'blue_900'} color={'gray_opacity_50'} href={href}>
                    {'다시 등록하기'}
                </Btn>
            }
        >
            <S.CaptionWrapper>
                <Label contents={'입력해주신 내용을 확인하는 과정에서 재확인이 필요한 점이 있습니다.'} color={'gray_opacity_600'} fontStyle={'body2'} />
            </S.CaptionWrapper>
            <S.RejectWrapper>
                {rjectInfoList.map((item, index) => (
                    <Label key={index} contents={`- ${item}`} fontStyle={'caption'} color={'red_900'} />
                ))}
            </S.RejectWrapper>
        </FormStatusInfo>
    );
}

export default ApproveReject;
